import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';

export class EditCertificationService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getAvailablePrerequisites = async (id: string) => {
    const response = await this.axiosInstance.get<Result<{ id: string; title: string }[]>>(
      `/api/admin/learning-hub/certification-tests/${id}/available-prerequisites`
    );
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching prerequisites.');
  };
}
